import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ModalButtons } from '@fcom/ui-components';
import { BoundType } from '@fcom/dapi';
import { FinnairBoundItem, FinnairCabinClass, FinnairItineraryItemFlight, FinnairOrder } from '@fcom/dapi/api/models';
import { getTails, isByBusOnly } from '@fcom/common-booking/utils/common-booking.utils';

@Component({
  selector: 'fin-booking-flight',
  templateUrl: './flight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingFlightComponent implements OnInit {
  readonly ModalButtons = ModalButtons;
  readonly BoundType = BoundType;

  modalOpen = false;

  /**
   * Flight Bound Information
   */
  @Input() bound: FinnairBoundItem;

  /**
   * A map of the locations in the bound/booking to get city and airport names
   */
  @Input() locations: FinnairOrder['locations'];

  /**
   * Type of bound to render in the timeline
   */
  @Input() type: BoundType = null;

  @Input()
  isBookingFlow = false;

  tails: string[];
  isByBusOnly: boolean;
  cabin: FinnairCabinClass;

  ngOnInit(): void {
    this.tails = getTails(this.bound);
    this.isByBusOnly = isByBusOnly(this.bound);
    this.cabin = this.getCabinClass(this.bound);
  }

  openViewDetails(): void {
    this.modalOpen = true;
  }

  getCabinClass(bound: FinnairBoundItem): FinnairCabinClass {
    return bound.cabinClass ?? (bound.itinerary[0] as FinnairItineraryItemFlight).cabinClass;
  }
}
